import { toast } from 'react-hot-toast';
import { checkBeforeOutbound } from '../utils/subscriptionError';
import { getAuthToken } from '../utils/getAuthToken';

export function useSubscriptionGuard() {
  const guard = async (featureKeys = []) => {
    const check = await checkBeforeOutbound(getAuthToken, featureKeys);
    if (check.blocked) {
      toast.error(check.message, { id: 'subscription-blocked', duration: 5000 });
      return false;
    }
    return true;
  };
  return { guard };
}
